import { Injectable } from '@angular/core';
import { PAYMASH_PROFILE } from '@profile';
import { ElasticLogger as ElasticLoggerBase } from '@paymash/logger-capacitor';
import { HttpClient as CapHttpClient } from '@paymash/capacitor-http-plugin';
import { SERVER_CONFIG } from '@shared/constants/server.const';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ElasticLogger extends ElasticLoggerBase {
  constructor(private httpClient: HttpClient) {
    super(CapHttpClient, {
      serverUrl: `${SERVER_CONFIG.PUBLIC_URL}/logs`,
      system: `pm.pos.${PAYMASH_PROFILE.APP_ENV}`,
      username: PAYMASH_PROFILE.LOGGER.username,
      password: PAYMASH_PROFILE.LOGGER.password,
      debug: !PAYMASH_PROFILE.isProduction,
    });
  }

  async post(url: string, headers: { [p: string]: string }, data: unknown): Promise<void> {
    // Same default as LogService.registerReporters: a resolved no-op here makes the reporter delete the file unsent.
    const isLoggerEnable: boolean = (localStorage.getItem('enableLogs') ?? 'true') === 'true';
    if (!isLoggerEnable) {
      return;
    }

    let newHeaders = new HttpHeaders();
    Object.keys(headers).forEach((key) => (newHeaders = newHeaders.append(key, headers[key])));
    await firstValueFrom(this.httpClient.post(url, data, { headers: newHeaders }));
  }
}
